export default __webpack_public_path__ + "static/ARTE-2-b65a4b30e5daa0fd8d4ea5ea8477ae78.jpg";